const formatPeriodicity = periodicity => {
  switch (periodicity) {
    case 1:
      return 'Mensal'
    case 2:
      return 'Bimestral'
    case 3:
      return 'Trimestral'
    case 4:
      return 'Quadrimestral'
    case 6:
      return 'Semestral'
    case 12:
      return 'Anual'
    case 24:
      return 'Bienal'
    default:
      return periodicity
  }
}

export default formatPeriodicity
